import type { LucideIcon } from 'lucide-react';
import { X } from 'lucide-react';
import type { ComponentProps } from 'react';

import { Button } from '@/shared/ui/shadcn/button';
import { cn } from '@/lib/utils';

export interface ActionChipProps extends Omit<
  ComponentProps<typeof Button>,
  'children' | 'variant' | 'size'
> {
  icon: LucideIcon;
  label: string;
  showLabel?: boolean;
  selected?: boolean;
}

export function ActionChip({
  icon: Icon,
  label,
  showLabel = false,
  selected = false,
  className,
  ...props
}: ActionChipProps) {
  return (
    <Button
      variant="chip"
      size="chip"
      radius="pill"
      className={cn('gap-1.5', selected && 'border-white', className)}
      aria-pressed={selected}
      {...props}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {showLabel ? <span>{label}</span> : <span className="sr-only">{label}</span>}
      {selected && showLabel && <X className="h-3.5 w-3.5" aria-hidden="true" />}
    </Button>
  );
}
